/* eslint-disable func-style */
import Vue from 'vue';
import Router from 'vue-router';
import LoginRouter from './login';
import MainRouter from './main';
import chargeManagement from './chargeManagement';
import ReceiptRouter from './receipt';
import ReportRouter from './report';
import StudentInfo from './studentInformation';
import Tuition from './tuitionManagement';
import Pmd from './partyMembershipDues';
import Donation from './donation';
import CostExpenses from './costExpenses';
import Examination from './examination';
import MaterialManage from './MaterialManage';
import dsf from './dsf';
// import PersonalInformation from './personalInformation'

import PersonalInformation from './personalInformation';


import OnlineCollection from './OnlineCollection';
import AuditLogging from './auditLogging';
import InvoiceRouter from './invoice';
import serviceRouter from './onSiteService';
import RransactionRouter from './transaction';
import Statistics from './statistics';
import NotFound from '../pages/NotFound';
import SysMenuRouter from './sysMenu';
import Students from './students';
import WaterElectricity from './waterElectricity';
import costCarryManagement from './costCarryManagement';
import k12 from './k12';
import RefundToSave from './RefundToSave';
import generationChargeRouter from './generationCharge';
import nonetaxSettle from './nonetaxSettle';
// console.log('generationChargeRouter=======',generationChargeRouter)
Vue.use(Router);
export default new Router({
	mode: 'history',
	base: 'epay',
	routes: [
		{ path: '*', component: NotFound },
		...dsf,
		...RefundToSave,
		...MaterialManage,
		...k12,
		...LoginRouter,
		...MainRouter,
		...chargeManagement,
		...OnlineCollection,
		...AuditLogging,
		...ReceiptRouter,
		...ReportRouter,
		...serviceRouter,
		...Statistics,
		...RransactionRouter,
		...StudentInfo,
		...Tuition,
		...Pmd,
		...Donation,
		...CostExpenses,
		...Examination,
		...InvoiceRouter,
		...SysMenuRouter,
		...Students,
		...StudentInfo,
		...PersonalInformation,
		...WaterElectricity,
		...costCarryManagement,
		...generationChargeRouter,
		...nonetaxSettle,
	],
});
